/**
 * Checks that the specified parameter is a non-empty, well-formed string (for database queries)
 *
 * @param {string} param The input string to validate
 * @returns {boolean} A `boolean` indicating whether the original string was valid
 */
export default function validateString(param) {
  return typeof param === 'string' && param.trim().length > 0;
}
